import { BaseComponent } from 'components/BaseComponent';
import { ITemplateState } from 'components/Cart';
import { cartService } from 'services/CartService';
import React from 'react';
import { BannerCenter } from './BannerCenter/index';
import MultiStep from './MultiStep/index';
import Footer from './../../Footer/index';
import OneClickBuy from './OneClickBuy';
import Hidden from '@material-ui/core/Hidden';
import Language from 'components/Language';
import { enProductType } from 'enums/enProductType';

const styles = require('./theme.css');

interface IState extends ITemplateState {
}

export default class HotsiteTheme extends BaseComponent<IState, any> {

  constructor(props: any) {
    super(props);
  }

  componentDidMount() {

    this.observeState({ cart: null }, cartService.getCart());
    this.observeState({ config: null }, cartService.getConfig());
  }

  render() {
    if (!this.state) {
      return null;
    }

    const { cart, config } = this.state;
    const product = cart.products[0];
    const bannerCenter = config.template.media.bannerCenter;
    const bannerYoutube = config.template.media.bannerYoutube;
    const productTitle = cart.title;

    return (
      <div className={`${styles.component} theme-hotsite`}>
        <Language />
        <div className='chk-main-container theme-background-color theme-background-image'>
          <div className={`chk-content-container ${cart.config.productType !== enProductType.PHYSICAL ? 'chk-with-language-selector' : ''}`}>
            <div className='chk-media-container'>

              <Hidden smDown>
                <BannerCenter media={bannerYoutube || `${bannerCenter}`} isVideo={bannerYoutube ? true : false} title={productTitle} />
              </Hidden>
              <div className='links'>
                <Footer />
              </div>
            </div>
            <div className='chk-form-container'>
              <div className='chk-inner-container'>
                {cart.config.isOneClick
                  ? <OneClickBuy onPay={this.props.onPay} hiddenFooter />
                  : <MultiStep product={product} onPay={this.props.onPay} />
                }
              </div>
              <Hidden mdUp>
                <div className='links'>
                  <Footer />
                </div>
              </Hidden>
            </div>
          </div>
        </div>
      </div>
    );
  }
}


// WEBPACK FOOTER //
// ./src/components/Cart/Templates/Hotsite/index.tsx